$(document).ready(function () {
  let slidesToShow = 4;

  if ($(".chris-container.hide .product-slider").length) {
    slidesToShow = 5;
  }

  $(".product-slider").slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0650/8940/5150/files/Button_-_Slide_right.png?v=1729061945" alt="Previous"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0650/8940/5150/files/Button_-_Slide_right_1.png?v=1729061945" alt="Next"></button>`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShow > 3 ? 3 : slidesToShow, // limit to 3 for medium screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: slidesToShow > 2 ? 2 : slidesToShow, // limit to 2 for smaller screens
          slidesToScroll: 1,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          dots: false,
          arrows: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          arrows: true,
          dots: false,
          variableWidth: false,
        },
      },
    ],
  });
});
